import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export const PickupPincodeOptions: DropdownOptionType[] = [{ value: '403507', display: '403507' }];

export const ProductIdsOptions: DropdownOptionType[] = [
  { value: '1', display: 'DOX' },
  { value: '2', display: 'NON DOX BY SURFACE' },
  { value: '3', display: 'NON DOX BY AIR' },
  { value: '4', display: 'DOX EXPRESS' },
  { value: '18', display: 'NON DOX EXPRESS' },
];

export const nandanInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  product_id: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Product ID is required'),
  pickup_pincode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Pickup pincode is required'),
  con_no: Yup.string()
    .required('Consignment No. is required')
    .min(13, 'Consignment No. must be at least 13 characters'),
});

export interface nandanInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  pickup_pincode: string;
  product_id: string;
  con_no: string;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: nandanInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'shree_nandan_courier_limited';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }
  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
